import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

export default function useAdminGuard() {
  const navigate = useNavigate();
  const { isLoggedIn, userEmail } = useAuth();
  const nickname = localStorage.getItem("nickname");

  useEffect(() => {
    if (!isLoggedIn || userEmail !== "ljw@naver.com" && nickname !== "관리자") {
      navigate("/"); // 권한 없으면 메인으로
    }
  }, [isLoggedIn, userEmail, nickname, navigate]);
}
